import orginJSONP from 'jsonp'

var baiduMapKey = 'wuQ2c8OGezvhhqHALNa8517s4z7Ni2l2'
var navigationbaiduMapKey = 'qxtCyBPvXCU6R7e0PQxdOFr9dDxtklUc'// 已失效，未知账号KEY
// var mybaiduMapKey = 'DP8aHPecyqOq8n307wnxGOe6uNcio0lQ'

export default function jsonp (url, data, option) {
  url += (url.indexOf('?') < 0 ? '?' : '&') + param(data)
  return new Promise((resolve, reject) => {
    orginJSONP(url, option, (err, data) => {
      if (!err) {
        resolve(data)
      } else {
        reject(err)
      }
    })
  })
}

function param (data) {
  let url = ''
  for (var k in data) {
    let values = data[k] !== undefined ? data[k] : ''
    url += '&${k}=${encodeURIComponent(values)}'
  }
  return url ? url.substring(1) : ''
}

export function reqReverseGeocoderDetail (lat, lon, callBack) {
  jsonp('https://api.map.baidu.com/reverse_geocoding/v3/?ak=' + baiduMapKey + '&output=json&extensions_poi=1&radius=5000&coordtype=gcj02ll&location=' + lat + ',' + lon, null).then(data => {
  // console.log(data)
    data = data.result
    if (callBack) {
      callBack(data)
      return callBack
    }
  }).catch(err => {
    console.log(err)
  })
}

export function reqReverseGeocoder (lat, lon, callBack) {
  jsonp('https://api.map.baidu.com/reverse_geocoding/v3/?ak=' + baiduMapKey + '&output=json&extensions_poi=1&radius=5000&coordtype=wgs84ll&location=' + lat + ',' + lon, null).then(data => {
  // console.log(data)
    data = data.result
    if (callBack) {
      callBack(data.formatted_address + (data.sematic_description == null ? '' : data.sematic_description))
      return callBack
    }
  }).catch(err => {
    console.log(err)
  })
}

export function reqRegion (lat, lon, callBack) {
  jsonp('https://api.map.baidu.com/reverse_geocoding/v3/?ak=' + baiduMapKey + '&output=json&extensions_poi=1&radius=5000&coordtype=wgs84ll&location=' + lat + ',' + lon, null).then(data => {
  // console.log(data)
    data = data.result
    if (callBack) {
      console.log(data)
      callBack(data.addressComponent.city)
      // return callBack
    }
  }).catch(err => {
    console.log(err)
  })
}

export function reqSearchPOI (query, reg, callBack) {
  jsonp('http://api.map.baidu.com/place/v2/search?query=' + query + '&region=' + reg + '&output=json&ak=' + baiduMapKey, null).then(data => {
  // console.log(data)
    if (callBack) {
      callBack(data)
    }
  }).catch(err => {
    console.log(err)
  })
}

export function reqSearchDirection (origin, destination, tactics, callBack) {
  jsonp('http://api.map.baidu.com/direction/v2/driving?origin=' + origin + '&destination=' + destination + '&ak=' + mybaiduMapKey + '&tactics=' + tactics, null).then(data => {
    // console.log(data)
    if (callBack) {
      callBack(data)
    }
  }).catch(err => {
    console.log(err)
  })
}
